module.exports = __webpack_public_path__ + "static/media/oct 2021.ab2b437e.svg";